import React from "react";

const Iframe = ({ url, title, className, ...other }) => (
    <iframe src={url} className={className} title={title} {...other} />
);

export default Iframe;
